'use strict';

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');

module.exports = function () {
	$('body').on('submit', 'form.header-login', function (e) {
		var form = $(this);
		e.preventDefault();
		var url = form.attr('action');
		form.spinner().start();

		$.ajax({
			url: url,
			type: 'post',
			dataType: 'json',
			data: form.serialize(),
			success: function (data) {
				form.spinner().stop();
				if (!data.success) {
					formValidation(form, data);
					$('form.login').trigger('login:error', data);
				} else {
					$('form.login').trigger('login:success', data);
					location.href = window.location.href;
				}
			},
			error: function (data) {
				if (data.responseJSON.redirectUrl) {
					window.location.href = data.responseJSON.redirectUrl;
				} else {
					$('form.login').trigger('login:error', data);
					form.spinner().stop();
				}
			}
		});
		return false;
	});
};
